import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    templateUrl: './unauthorized.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnauthorizedPage implements OnInit {

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    if (this.authenticationService.currentUserValue.sub) {
      this.authenticationService.logout();
    }
  }
}
